import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { IChatDraftMessage } from '@nimbus-global/features/chat/models/chat-twilio.model';
import { ChatTwilioApiClient } from '@nimbus-global/features/chat/services/twilio/chat-twilio.api-client';

@Injectable({
  providedIn: 'root',
})
export class ChatDraftService {
  private currentDraftText = '';
  private readonly savingConversationIds = new Set<string>();

  public constructor(private readonly apiClient: ChatTwilioApiClient) {}

  public setCurrentDraftText(text: string): void {
    this.currentDraftText = text;
  }

  public getCurrentDraftText(): string {
    return this.currentDraftText;
  }

  public saveDraft(apiUrl: string, conversationId: string, message: string): Observable<void> {
    if (this.savingConversationIds.has(conversationId)) {
      return EMPTY;
    }
    this.savingConversationIds.add(conversationId);
    const draft: IChatDraftMessage = { body: message };
    return this.apiClient.saveDraft(apiUrl, draft).pipe(finalize(() => this.savingConversationIds.delete(conversationId)));
  }
}
